import { render } from "./OuterCartonTypesettingButton.vue?vue&type=template&id=c8233498"
import script from "./OuterCartonTypesettingButton.vue?vue&type=script&lang=ts"
export * from "./OuterCartonTypesettingButton.vue?vue&type=script&lang=ts"

import "./OuterCartonTypesettingButton.vue?vue&type=style&index=0&id=c8233498&lang=less"
script.render = render

export default script